import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLoginComponent } from './user-login/user-login.component';
import { AuthenticationGuard } from './authentication.guard';
import { HomeComponent } from './home/home.component';
import { UserLandingComponent } from './settings/user-landing/user-landing.component';
import { RoleLandingComponent } from './settings/role-landing/role-landing.component';
import { OrganizationComponent } from './settings/organization/organization.component';
// import { AutoClosureRuleComponent } from './alerts/auto-closure-rule/auto-closure-rule.component';
import { SummaryTableComponent } from './alerts/side_nav_comp/summary-table/summary-table.component';
import { AlertsComponent } from './alerts/alerts.component';
import { AutoInvestigateRuleComponent } from './shared/auto-investigate-rule/auto-investigate-rule.component';
import { AutoClosureComponent } from './shared/auto-closure/auto-closure.component';
import { ConsolidationRuleComponent } from './shared/consolidation-rule/consolidation-rule.component';
// import { ImportIntelListComponent } from './rule/create-intel-list/import-intel-list/import-intel-list.component';
import { AutoClosureRuleComponent } from './shared/auto-closure-rule/auto-closure-rule.component';
import { LogSearchComponent } from './log-search/log-search.component';
import { SearchOverviewComponent } from './log-search/notepad/search-overview/search-overview.component';
import { IntelListModule } from './intel-list/intel-list.module';
// import { CreateIntelListComponent } from './rule/create-intel-list/create-intel-list.component';
import { IntelListComponent } from './intel-list/intel-list.component';
import { DirectToSignalComponent } from './shared/direct-to-signal/direct-to-signal.component';
import { DashboardPreviewComponent } from './designer/dashboard-preview/dashboard-preview.component';
import { HomeLandingComponent } from './home-landing/home-landing.component';




const routes: Routes = [
  { path: 'login', component: UserLoginComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [AuthenticationGuard] },
  // { path: 'home', component: HomeLandingComponent, canActivate: [AuthenticationGuard] },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthenticationGuard] },
  { path: 'designer', loadChildren: () => import('./designer/designer.module').then(m => m.DesignerModule), canActivate: [AuthenticationGuard] },
  { path: 'rule', loadChildren: () => import('./rule/rule.module').then(m => m.RuleModule), canActivate: [AuthenticationGuard] },
  //{ path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule), canActivate: [AuthenticationGuard] },
  { path: 'user', component: UserLandingComponent },
  { path: 'role', component: RoleLandingComponent },
  { path: 'organization', component: OrganizationComponent },
  { path: 'explorelogs', loadChildren: () => import('./explore-logs/explore-logs.module').then(m => m.ExploreLogsModule) },
  { path: 'collective-dashboard', loadChildren: () => import('./collective-dashboard/collective-dashboard.module').then(m => m.CollectiveDashboardModule) },
  { path: 'ticketing', loadChildren: () => import('./ticketing/ticketing.module').then(m => m.TicketingModule) },
  { path: 'pipelinestats', loadChildren: () => import('./pipeline-stats/pipeline-stats.module').then(m => m.PipelineStatsModule) },
  // { path: 'alerts',loadChildren: () =>import('./alerts/alerts.module').then(m => m.AlertsModule),canActivate: [AuthenticationGuard]},
  // { path: 'auto-closure-rule', component: AutoClosureRuleComponent }, 
  { path: 'auto-investigate-rule', component: AutoInvestigateRuleComponent},
  { path: 'summary-table', component: SummaryTableComponent },   
  { path: 'log-search', loadChildren: () => import('./log-search/log-search.module').then(m => m.LogSearchModule),canActivate: [AuthenticationGuard] },
  { path: 'alerts', loadChildren: () => import('./alerts/alerts.module').then(m => m.AlertsModule),canActivate: [AuthenticationGuard] },
  { path: 'intel-list', loadChildren: () => import('./intel-list/intel-list.module').then(m => m.IntelListModule),canActivate: [AuthenticationGuard] },
  { path: 'alert' , component: AlertsComponent},
  { path: 'auto-closure', component: AutoClosureComponent},
  { path: 'consolidation-rule', component: ConsolidationRuleComponent},
  // { path: 'import-intel-list', component: ImportIntelListComponent},
  { path: 'auto-closure-rule', component: AutoClosureRuleComponent},
  { path: 'direct-to-signal', component: DirectToSignalComponent},
  { path: 'dashboard-preview' , component: DashboardPreviewComponent},
  // { path: 'intel' , component: IntelListComponent}
  // { path: 'log-search', component: LogSearchComponent}



  { path: '**', redirectTo: 'login', pathMatch: 'full' }, // always needs to be last , otherwise it will override other routes

];

@NgModule({
  // imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }